import { ColDef } from 'ag-grid-community';
import { DefaultCellTooltip } from 'components/grids/tooltip/DefaultCellTooltip';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useColumnDefsForApprovalList = () => {
  const { t } = useTranslation();

  const defaultColDef = useMemo((): ColDef => {
    return {
      sortable: true,
      resizable: true,
      cellStyle: { textAlign: 'center' },
      tooltipComponent: DefaultCellTooltip,
    };
  }, []);

  const colDefs = useMemo((): any[] => {
    return [
      {
        headerName: t('컬럼1코드', 'No.'),
        field: 'column1',
        tooltipField: 'IP000000',
        width: 80,
      },
      {
        headerName: t('컬럼2코드', 'Vender ID'),
        field: 'column2',
        tooltipField: 'column2',
        width: 110,
      },
      {
        headerName: t('컬럼3코드', '업체명(ERP)'),
        field: 'column3',
        tooltipField: 'column3',
        minWidth: 280,
        flex: 1,
      },
      {
        headerName: t('컬럼4코드', '업체명(거래처)'),
        field: 'column4',
        tooltipField: 'column4',
        minWidth: 280,
        flex: 1,
      },
      {
        headerName: t('컬럼5코드', '이름'),
        field: 'column5',
        tooltipField: 'column5',
        width: 95,
      },
      {
        headerName: t('컬럼6코드', '이메일'),
        field: 'column6',
        tooltipField: 'column6',
        width: 105,
      },
      {
        headerName: t('컬럼6코드', '엔솔법인코드'),
        field: 'column7',
        tooltipField: 'column7',
        width: 120,
      },
      {
        headerName: t('컬럼6코드', '엔솔담당자'),
        field: 'column8',
        tooltipField: 'column8',
        width: 110,
      },
      {
        headerName: t('컬럼6코드', '비교'),
        field: 'column9',
        tooltipField: 'column9',
        width: 95,
      },
      {
        headerName: t('컬럼6코드', '등록상세'),
        field: 'column10',
        tooltipField: 'column10',
        width: 95,
      },
      {
        headerName: t('컬럼6코드', '처리상태'),
        field: 'column11',
        tooltipField: 'column11',
        width: 95,
      },
      {
        headerName: t('컬럼6코드', '요청일시'),
        field: 'column12',
        tooltipField: 'column12',
        width: 95,
      },
    ];
  }, []);

  const handleAprvDetailBtn = (data) => {
    console.log('화면 연결이 필요합니다.');
  };

  return { defaultColDef, colDefs };
};
